<template>
    <div>
        <select class="form-control" v-model="current" @change="update">
            <option v-for="variant in variants" :key="variant.id" :value="variant.sku">
                <template v-if="variant.options.length">
                    <span v-for="option in variant.options" :key="option">{{ option }} </span>
                </template>
                <template v-else>{{ variant.sku }}</template>
            </option>
        </select>
    </div>
</template>

<script>
    import Product from '../../Services/Product.js';

    export default {
        props: {
            initial: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        data() {
            return {
                product: Product,
                current: this.initial[0].sku
            }
        },
        methods: {
            update() {

                let variant = null;

                this.variants.forEach(element => {
                    if (element.sku == this.current) {
                        variant = element;
                    }
                });

                this.product.setVariant(variant);
            }
        },
        computed: {
            variants() {
                return this.product.variants;
            }
        },
        mounted() {
            this.product.setVariants(this.initial);
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Product/VariantSwitcher.vue